<template>
    <!-- 我的奖品组件 -->
    <div class="my-prizes">
        <div class="title">我的奖品</div>
        <!-- 我的奖品列表 -->
        <div v-if="myPrizesList.length > 0"
            class="prizes-list">
            <div v-for="(item, index) in myPrizesList"
                :key="index"
                class="item">
                <!-- 奖品类型为积分时，显示积分数 -->
                <div v-if="item.rewardType === BWC.GoodsType.accumulatePoints"
                    class="prizes-name">{{ item.pointValue }}积分</div>
                <div v-else
                    class="prizes-name">{{ item.rewardName }}</div>
                <!-- 查看按钮-->
                <div class="view-btn"
                    @click="viewPrizes(item)">{{ getBtnText(item) }}</div>
            </div>
        </div>
        <!-- 暂无中奖记录 -->
        <div v-else
            class="no-records">
            暂无奖品
        </div>
    </div>
</template>
<script>
import { BigWheelConstants as BWC } from '../../../common/global-variable';

export default {
  name: 'MyPrizes',
  components: {},
  props: {
    myPrizesList: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      BWC: BWC,
    };
  },
  computed: {},
  created() {},
  methods: {
    viewPrizes(item) {
      this.$emit('viewPrizes', item);
    },
    getBtnText(item) {
      // 奖品类型是积分，跳转配置了自定义链接
      if (item.jumpType === BWC.JumpType.customLink && (item.rewardType === BWC.GoodsType.accumulatePoints || item.goodsType === BWC.GoodsType.accumulatePoints)) {
        return '去使用'
      } else {
        return '查看'
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.my-prizes {
  background-color: #fff;
  border-radius: 7px;
  padding: 15px;
  .title {
    font-family: HONORSansBrand-DemiBold;
    font-size: 16px;
    color: #256fff;
    text-align: center;
    font-weight: 600;
    margin-bottom: 14px;
  }
  .prizes-list {
    .item {
      margin: 5px 0;
      display: flex;
      justify-content: space-between;
      .prizes-name {
        max-width: 70%;
        text-align: left;
        line-height: 24px;
        font-size: 12px;
        font-family: HONORSansBrand-Regular;
        color: #333333;
        font-weight: 400;

        // 单行溢出文本省略处理
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .view-btn {
        padding: 2px 14px;
        border: 1px solid #256fff;
        border-radius: 25px;
        font-family: HONORSansBrand-Regular;
        font-size: 12px;
        color: #256fff;
        font-weight: 400;
      }
    }
  }
  .no-records {
    height: 58px;
    line-height: 58px;
    font-family: HONORSansBrand-Regular;
    font-size: 12px;
    color: #c3c3c3;
    font-weight: 400;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/lucky-draw/lucky-draw-page/new-blind-box/components/my-prizes.vue